/** @format */

import { Container, Unstable_Grid2 as Grid } from "@mui/material";
import { useEffect, useState } from "react";
import File from "Pages/File";
import { useDispatch, useSelector } from "react-redux";
import useTitle from "Hooks/useTitle";
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import { GetCartInfo, ListJozveStudent, ShowProfile } from "Services/Student";
import { useNavigate } from "react-router-dom";
import { getUserService } from "Services/auth";
import { showProfile } from "Redux/Admin/AdminSlice";
import { OverviewBudget } from "components/StatusCard";
import DownloadIcon from '@mui/icons-material/Download';
import { useTranslation } from "react-i18next";
const Dashboard = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [jozve, setJozve] = useState([]);

  const [data, setData] = useState({
    pricewallet: 0,
    numJozveActive: 0,
    numJozvePending: 0,
  });

  const { type } = useSelector((state) => state["Admin"].userInfo || {});
  const navigate = useNavigate();
  const dispatch = useDispatch();
const {t} = useTranslation();
  useTitle(t("Header.Student"));

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await getUserService();
        const cart = await GetCartInfo();
        setData(cart?.data || {});

        const userType = response?.data?.value?.type;

        const jozveList = await ListJozveStudent();
        setJozve(jozveList?.data || []);

        const res = await ShowProfile();
        dispatch(showProfile(res?.data));

        if (userType === 0) {
          navigate("/auth/signup");
        }
      } catch (error) {
        console.error("Failed to fetch user profile:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchProfile();
  }, [dispatch, navigate]);

  const cardData = [
    {
      icon: <AccountBalanceWalletIcon />,
      name: t("card.balance"),
      value: data.pricewallet,
    },
    {
      icon: <FileCopyIcon />,
      name:  t("card.active"),
      value: data.numJozveActive,
    },
    {
      icon: <DownloadIcon />,
      name:  t("card.pending"),
      value: data.numJozvePending,
    },
  ];

  return (
    <Container maxWidth={false}>
      <Grid container spacing={3} justifyContent="center">
        {cardData.map((c, i) => (
          <Grid xs={12} sm={6} lg={4} key={i}>
            <OverviewBudget
              id={i}
              icon={c.icon}
              title={c.name}
              sx={{ height: "100%" }}
              value={c.value || 0}
              loading={isLoading}
            />
          </Grid>
        ))}
        <Grid xs={12}>
          <File />
        </Grid>
      </Grid>
    </Container>
  );
};


export default Dashboard;
